import { baseURL as BASE_URL } from "../Endpoints";

const APPRAISAL = {
  GET_APPRAISALS: `${BASE_URL}/appraisal`,
  UPLOAD_BULK_APPRAISALS: `${BASE_URL}/appraisal/bulk/upload`,
  EXPORT_APPRAISALS_REPORT: `${BASE_URL}/appraisal/export`,
};

export default APPRAISAL;
